// extracted by mini-css-extract-plugin
module.exports = {"frag":"Tab3_frag__gLv3c"};